import { Container, Stack, Typography, Box } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import InsertEmoticonOutlinedIcon from "@mui/icons-material/InsertEmoticonOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import PageLayout from "../../shared/components/PageLayout";
import CTASection from "../../shared/components/CTASection";
import { sharedStyles } from "../../shared/utils/sharedStyles";
import { colorPalette } from "../../shared/utils/constants";

const iconStyle = {
  fontSize: "32px",
  color: colorPalette.sectionTitle,
};

const features = [
  {
    icon: <StarBorderOutlinedIcon sx={iconStyle} />,
    text: "Satisfactory Work",
  },
  {
    icon: <InsertEmoticonOutlinedIcon sx={iconStyle} />,
    text: "Happy Customers",
  },
  {
    icon: <GroupsOutlinedIcon sx={iconStyle} />,
    text: "Professional Team",
  },
  {
    icon: <AssignmentOutlinedIcon sx={iconStyle} />,
    text: "Flexible Contracts",
  },
];

const AboutUsPage = () => {
  return (
    <PageLayout>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundColor: colorPalette.headerBackground,
          color: colorPalette.white,
          py: 8,
          mt: 15,
          textAlign: "center",
        }}
      >
        <Container>
          <Typography
            variant="h2"
            sx={{
              fontFamily: "'Bebas Neue', sans-serif",
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              mb: 2,
            }}
          >
            About Us
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "'Barlow', sans-serif",
              fontWeight: 300,
              maxWidth: 700,
              mx: "auto",
              opacity: 0.9,
            }}
          >
            Your trusted partner for professional cleaning services in Melbourne
          </Typography>
        </Container>
      </Box>

      {/* Content Section */}
      <Container sx={sharedStyles.contentContainer}>
        <Typography variant="h4" sx={sharedStyles.sectionTitle}>
          Radiant Property Management
        </Typography>

        <Stack spacing={3} mt={3}>
          <Typography color="text.secondary" sx={sharedStyles.paragraph}>
            We are Radiant Property Management, where cleanliness meets
            convenience. We are a dedicated team of professionals committed to
            delivering top-notch cleaning services tailored to meet your needs.
            With years of experience in the industry, we understand the
            importance of a clean and healthy environment for your businesses.
          </Typography>

          <Typography color="text.secondary" sx={sharedStyles.paragraph}>
            We specialise in professional commercial cleaning and property
            services in Melbourne, offering customized services for a wide range
            of businesses, including Offices, Childcare facilities, Hotels,
            Gyms, Retail stores, and all type of Commercial cleaning. With over
            a decade of experience in the industry, our focus on uncompromising
            quality, professionalism, and a business-friendly approach
            guarantees exceptional cleaning services and exceptional customer
            care for your commercial facility. Elevate your standards of
            cleanliness and service excellence with us.
          </Typography>

          <Typography color="text.secondary" sx={sharedStyles.paragraph}>
            At Radiant Property Management, we pride ourselves on our attention
            to detail and commitment to customer satisfaction. Our skilled
            cleaners undergo rigorous training and utilize the latest techniques
            to ensure exceptional results every time.
          </Typography>

          <Typography color="text.secondary" sx={sharedStyles.paragraph}>
            Choose Radiant Property Management for a spotless space and peace of
            mind. Let us handle the dirty work while you focus on what matters
            most. Contact us today to schedule your cleaning appointment!
          </Typography>
        </Stack>

        {/* Features Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
            mt: 8,
            flexWrap: "wrap",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: colorPalette.sectionTitle,
              fontFamily: "'Bebas Neue', sans-serif",
            }}
          >
            Why Choose Us?
          </Typography>

          <Box sx={{ display: "flex", gap: 3, alignItems: "center", flexWrap: "wrap", justifyContent: "center" }}>
            {features.map((feature, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {feature.icon}
                <Typography
                  sx={{
                    color: colorPalette.headerBackground,
                    fontSize: "16px",
                    fontFamily: "'Barlow', sans-serif",
                    fontWeight: 400,
                    textAlign: "center",
                  }}
                >
                  {feature.text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Contact Section */}
        <CTASection title="Ready to Get Started?" />
      </Container>
    </PageLayout>
  );
};

export default AboutUsPage;
